import { baseURL } from '@laborability/commons';
import { useEffect } from 'react';
import Loader from '../components/Loader';

const WELBEE_CALLBACK_PATH = '/api/v1/integrations/welbee/sso/callback';

function getHashSearchParams() {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');
  return new URLSearchParams(queryIndex >= 0 ? hash.substring(queryIndex + 1) : '');
}

function getFrontendHomeUrl() {
  return `${window.location.origin}${window.location.pathname}`;
}

function getApiBaseUrl() {
  if (!baseURL || baseURL === 'undefined') return window.location.origin;
  if (baseURL.startsWith('http')) return baseURL;

  const normalizedBaseUrl = baseURL.startsWith('/') ? baseURL : `/${baseURL}`;
  return `${window.location.origin}${normalizedBaseUrl}`;
}

export default function WelbeeSso() {
  useEffect(() => {
    const params = getHashSearchParams();
    const welbeeToken = params.get('token');

    if (!welbeeToken) {
      window.location.replace(getFrontendHomeUrl());
      return;
    }

    const callbackUrl = new URL(WELBEE_CALLBACK_PATH, getApiBaseUrl());
    callbackUrl.searchParams.set('token', welbeeToken);
    callbackUrl.searchParams.set('redirect_uri', getFrontendHomeUrl());
    window.location.replace(callbackUrl.toString());
  }, []);

  return <Loader />;
}